import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay.is-open {
  animation: none;
}
.navigation-logo-link:hover .navigation-logo-icon {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <div className="navigation-group navigation-group-left">
            <a href="/browse-by-category">
              <div className="navigation-link">
                <span className="navigation-link-text">Browse</span>
              </div>
            </a>
            <a href="/map-of-local-listings">
              <div className="navigation-link">
                <div className="navigation-icon-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                    ></path>
                  </svg>
                </div>
                <span className="navigation-link-text">Map View</span>
              </div>
            </a>
          </div>
          <div className="navigation-logo-container">
            <a href="/">
              <div aria-label="Dogeet Home" className="navigation-logo-link">
                <div className="navigation-logo-icon">
                  <span>Ð</span>
                </div>
                <span className="navigation-brand-name">Dogeet</span>
              </div>
            </a>
          </div>
          <div className="navigation-group navigation-group-right">
            <div className="navigation-doge-ticker">
              <span className="navigation-ticker-label">Ð1 =</span>
              <span className="navigation-ticker-value">$0.18</span>
            </div>
            <a href="/post-a-listing">
              <div className="btn btn-primary btn-sm">
                <div className="navigation-btn-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 12h14m-7-7v14"
                    ></path>
                  </svg>
                </div>
                <span>Post Listing</span>
              </div>
            </a>
            <button
              id="themeToggle"
              aria-label="Toggle theme"
              className="navigation-theme-btn"
            >
              <div className="navigation-theme-icon-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  className="navigation-icon-sun"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="4"></circle>
                    <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
                  </g>
                </svg>
              </div>
            </button>
          </div>
          <div className="navigation-mobile-toggle-group">
            <button
              id="themeToggleMobile"
              aria-label="Toggle theme"
              className="navigation-theme-btn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                className="navigation-icon-sun"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="4"></circle>
                  <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
                </g>
              </svg>
            </button>
            <button
              id="mobileMenuOpen"
              aria-label="Open menu"
              aria-expanded="false"
              className="navigation-hamburger"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <div className="navigation-logo-container">
            <a href="/">
              <div className="navigation-logo-link">
                <div className="navigation-logo-icon">
                  <span>Ð</span>
                </div>
                <span className="navigation-brand-name">Dogeet</span>
              </div>
            </a>
          </div>
          <button
            id="mobileMenuClose"
            aria-label="Close menu"
            className="navigation-close-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-5.5-3.5l-5 5m0-5l5 5"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <div className="navigation-mobile-doge-status">
            <span className="navigation-ticker-label">Ð1 = $0.18 USD</span>
          </div>
          <ul className="navigation-mobile-list">
            <li className="navigation-mobile-item">
              <a href="/browse-by-category">
                <div className="navigation-mobile-link">
                  <span>Browse Items</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/map-of-local-listings">
                <div className="navigation-mobile-link">
                  <span>Local Map</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/community-rules-safety">
                <div className="navigation-mobile-link">
                  <span>Community Rules</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/listing-page">
                <div className="navigation-mobile-link">
                  <span>Dogeet Help</span>
                </div>
              </a>
            </li>
          </ul>
          <div className="navigation-overlay-footer">
            <a href="/post-a-listing">
              <div className="navigation-full-btn btn btn-primary btn-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  className="navigation-icon24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 12h14m-7-7v14"
                  ></path>
                </svg>
                <span>
                  {' '}
                  Post New Listing
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<style>
        @keyframes slideIn {from {transform: translateX(100%);}
to {transform: translateX(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<script defer data-name="navigation-controls">
(function(){
const mobileMenuOpen = document.getElementById('mobileMenuOpen');
  const mobileMenuClose = document.getElementById('mobileMenuClose');
  const mobileOverlay = document.getElementById('mobileOverlay');

  if (mobileMenuOpen && mobileOverlay) {
    mobileMenuOpen.addEventListener('click', () => {
      mobileOverlay.classList.add('is-open');
      mobileMenuOpen.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileMenuClose && mobileOverlay) {
    mobileMenuClose.addEventListener('click', () => {
      mobileOverlay.classList.remove('is-open');
      mobileMenuOpen.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }

  // Close mobile menu on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileOverlay.classList.contains('is-open')) {
      mobileOverlay.classList.remove('is-open');
      mobileMenuOpen.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });

  // Close mobile menu on link click
  const mobileLinks = document.querySelectorAll('.navigation-mobile-link');
  mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
      mobileOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

const themeToggle = document.getElementById('themeToggle');
const html = document.documentElement;

// Initialize theme from localStorage or system preference
const storedTheme = localStorage.getItem('theme') ||
  (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

applyTheme(storedTheme);

function applyTheme(theme) {
  const suffix = theme === 'dark' ? 'dark' : 'light';

  // Update ALL active color variables to point to the correct theme
  html.style.setProperty('--color-primary', \`var(--color-primary-\${suffix})\`);
  html.style.setProperty('--color-secondary', \`var(--color-secondary-\${suffix})\`);
  html.style.setProperty('--color-accent', \`var(--color-accent-\${suffix})\`);
  html.style.setProperty('--color-neutral', \`var(--color-neutral-\${suffix})\`);
  html.style.setProperty('--color-surface', \`var(--color-surface-\${suffix})\`);
  html.style.setProperty('--color-on-surface', \`var(--color-on-surface-\${suffix})\`);
  html.style.setProperty('--color-on-surface-secondary', \`var(--color-on-surface-secondary-\${suffix})\`);
  html.style.setProperty('--color-on-primary', \`var(--color-on-primary-\${suffix})\`);
  html.style.setProperty('--color-surface-elevated', \`var(--color-surface-elevated-\${suffix})\`);
  html.style.setProperty('--color-on-secondary', \`var(--color-on-secondary-\${suffix})\`);
  html.style.setProperty('--color-on-accent', \`var(--color-on-accent-\${suffix})\`);
  html.style.setProperty('--color-border', \`var(--color-border-\${suffix})\`);
  html.style.setProperty('--color-outline', \`var(--color-outline-\${suffix})\`);
  html.style.setProperty('--color-overlay', \`var(--color-overlay-\${suffix})\`);
  html.style.setProperty('--color-backplate', \`var(--color-backplate-\${suffix})\`);
  html.style.setProperty('--color-scrim', \`var(--color-scrim-\${suffix})\`);

  html.setAttribute('data-theme', theme);
  localStorage.setItem('theme', theme);
}

function toggleTheme() {
  const currentTheme = html.getAttribute('data-theme');
  const newTheme = currentTheme === 'light' ? 'dark' : 'light';
  applyTheme(newTheme);
}

if (themeToggle) {
  themeToggle.addEventListener('click', toggleTheme);
}
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
